export function getTopCountriesByCount(data, countryList) {
  // Extract and sort data based on 'count' value in descending order, ensuring unique entries by location_code
  const uniqueEntries = new Map();

  data
    ?.map((entry) => {
      const curr_country = countryList?.find(
        (item) => item.location_code === entry.location_code
      );
      const countryLang = curr_country?.available_languages?.find(
        (item) => item.language_code === entry.language_code
      );
      if (!curr_country) return null;
      const processedEntry = {
        location_name: curr_country?.location_name,
        language_name: countryLang?.language_name,
        location_flag: curr_country?.flag,
        title: `${countryLang?.language_name} / ${curr_country?.location_name}`,
        count: entry.metrics.organic.count,
        etv: entry.metrics.organic.etv,
        ...entry,
      };
      return processedEntry;
    })
    ?.filter((item) => item != null && item != undefined)
    ?.forEach((item) => {
      // Ensure unique entries by location_code
      if (
        !uniqueEntries.has(item.location_code) ||
        uniqueEntries.get(item.location_code).count < item.count
      ) {
        uniqueEntries.set(item.location_code, item);
      }
    });

  // Return sorted unique entries
  return Array.from(uniqueEntries.values()).sort((a, b) => b.count - a.count);
}

export function getShortFormString(name) {
  if (!name || typeof name !== "string") {
    return ""; // Handle invalid input
  }

  // Step 1: Split by comma, trim, and filter out invalid or empty strings
  const words = name
    .split(",")
    .map((word) => word.trim().toUpperCase()) // Trim and convert to uppercase
    .filter((word) => word && word !== "NULL" && word !== "UNDEFINED"); // Remove invalid values

  // Step 2: Create a unique array
  const uniqueWords = [...new Set(words)];
  // Step 3: If the array is empty, return an empty string
  if (uniqueWords.length === 0) {
    return "";
  }

  const shortForms = uniqueWords.map((word) => {
    const parts = word.split(/\s+/); // Split words by spaces
    if (parts.length === 1) {
      // If it's a single word, take the first 2 letters
      return parts[0].slice(0, 2);
    } else {
      // For multi-word names, take the first letter of each word
      return parts.map((part) => part[0]).join("");
    }
  });

  // Join the results with commas
  return shortForms.join(", ");
}

export function getShortForm(name) {
  if (!name || typeof name !== "string") {
    return ""; // Handle invalid input
  }
  const words = name.trim().toUpperCase().split(/\s+/); // Split words by spaces
  if (words.length === 1) {
    // For single-word input, return the first 3 characters
    return words[0].slice(0, 2);
  } else {
    // For multi-word input, take the first letter of each word
    return words.map((word) => word[0]).join("");
  }
}
